module.exports = __webpack_public_path__ + "img/fill_form_icon.37e1c113.svg";